module.exports = __webpack_public_path__ + "img/universe.c20a5de5.png";